import Link from 'next/link';
import { useEffect, useState } from 'react';
import LogoutButton from '../LogoutButton';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import { useDispatch, useSelector } from 'react-redux';
import { cn, getAccountType, getUserDetails } from '../../../../utils';
import { getPrimaryRole } from '../../../../utils/authUtils';
import {
  EDIT_PROFILE_ROUTE,
  MY_PROFILE_ROUTE,
  PROFILE_ROUTE,
  SUBSCRIPTION_ROUTE,
} from '../../../../utils/routes';
import {
  getProfileDataAsync,
  setOpenAllProfilesModal,
  switchProfileAsync,
} from '../../../store/slices/common/userProfileSlice';
import SwitchProfileLoader from '../../Common/Loader/SwitchProfileLoader';
import UserAccountWithTick from '../../Common/UserAccountWithTick/UserAccountWithTick';

const MdAdd = dynamic(() => import('react-icons/md').then((mod) => mod.MdAdd));
const MdArrowRightAlt = dynamic(() =>
  import('react-icons/md').then((mod) => mod.MdArrowRightAlt)
);

const MenuItem = ({ link, label, style = '' }) => {
  return (
    <Link
      href={link}
      className={` flex items-center rounded-md p-2 hover:bg-border-light`}
    >
      <button
        className={cn(
          style,
          `text-start text-[14px] font-semibold leading-snug text-high`
        )}
      >
        {label}
      </button>
    </Link>
  );
};

export default function FlyoutMenuContent({}) {
  const dispatch = useDispatch();
  const router = useRouter();
  const pathname = router.asPath;
  const { city } = router.query;
  const userDetails = getUserDetails();
  const [activeProfile, setActiveProfile] = useState(null);
  const [secondProfile, setSecondProfile] = useState(null);
  const [switchLoading, setSwitchLoading] = useState(false);
  const lang = useSelector(({ common }) => common?.language);

  useEffect(() => {
    if (userDetails !== null) {
      setActiveProfile(
        userDetails?.profiles?.filter(
          (profile) =>
            profile.profile_public_id == userDetails?.profile_public_id
        )[0]
      );

      const otherProfiles = userDetails?.profiles?.filter(
        (profile) => profile.profile_public_id != userDetails?.profile_public_id
      );

      if (otherProfiles?.length > 0) {
        setSecondProfile(otherProfiles[0]);
      } else {
        setSecondProfile(null);
      }
    }
  }, []);

  const handleSwitchProfile = async (
    switchingProfileId,
    switchingProfilePublicId
  ) => {
    setSwitchLoading(true);
    await dispatch(switchProfileAsync({ to_profile: switchingProfileId }));
    await dispatch(
      getProfileDataAsync({ profileId: switchingProfilePublicId })
    );
    if (pathname.includes('/profile') || pathname.includes('/edit-profile')) {
      await router.replace(
        PROFILE_ROUTE({
          userId: userDetails?.user_public_id,
          profileId: switchingProfilePublicId,
          city,
        })
      );
    }
    if (pathname.includes('/edit-profile')) {
      await router.replace(
        EDIT_PROFILE_ROUTE({
          userId: userDetails?.user_public_id,
          profileId: switchingProfilePublicId,
          city,
        })
      );
    }
    window.location.reload();
    setSwitchLoading(false);
  };

  // if (switchLoading) return <SwitchProfileLoader />;
  return (
    <div className='w-full py-6 md:w-[258px]'>
      {switchLoading ? (
        <SwitchProfileLoader className='h-[418px] ' />
      ) : (
        <>
          <nav className='flex flex-col '>
            <span className='mb-[4px] px-4 text-[12px] font-semibold uppercase text-mid'>
              {lang?.common?.logins}
            </span>
            {userDetails?.profiles?.length === 20 ? null : (
              <Link href='/add-new-profile'>
                <button className='mb-[10px] flex items-center px-4 hover:text-black'>
                  <div className='mr-[8px] flex h-[40px] w-[40px] items-center justify-center rounded-full bg-[#EBEBEB]'>
                    <MdAdd />
                  </div>
                  <p className='mb-0 font-semibold'>
                    {lang?.common?.add_profile}
                  </p>
                </button>
              </Link>
            )}

            <div className='flex flex-col px-4'>
              <Link
                className='rounded-sm p-2 hover:bg-border-light'
                href={MY_PROFILE_ROUTE(city)}
              >
                <UserAccountWithTick
                  userName={activeProfile?.name}
                  imagePath={activeProfile?.profile_img?.path}
                  accountType={activeProfile?.account_type}
                  role={getPrimaryRole(activeProfile?.role, lang)}
                  isTicked={
                    activeProfile?.profile_public_id ==
                    userDetails?.profile_public_id
                  }
                />
              </Link>

              {secondProfile ? (
                <button
                  className='rounded-sm p-2 hover:bg-border-light'
                  onClick={() =>
                    handleSwitchProfile(
                      secondProfile?.id,
                      secondProfile?.profile_public_id
                    )
                  }
                >
                  <UserAccountWithTick
                    userName={secondProfile?.name}
                    imagePath={secondProfile?.profile_img?.path}
                    accountType={secondProfile?.account_type}
                    role={getPrimaryRole(secondProfile?.role, lang)}
                    isTicked={
                      secondProfile?.profile_public_id ==
                      userDetails?.profile_public_id
                    }
                  />
                </button>
              ) : null}
            </div>

            {userDetails?.profiles?.length > 2 ? (
              <button
                onClick={() => {
                  dispatch(setOpenAllProfilesModal(true));
                }}
                className='mx-4  flex cursor-pointer rounded-sm p-2 font-bold hover:bg-border-light'
              >
                {lang?.common?.view_all} (+{userDetails?.profiles?.length - 2})
              </button>
            ) : null}

            {userDetails?.is_admin != 1 &&
            userDetails?.apply_citywritter != 1 ? (
              <Link href={`/apply-as-a-city-writer?city=${city}`}>
                <div className=' mx-4 mt-2 bg-border-light p-[12px] text-black'>
                  <div className='flex items-center gap-2'>
                    <span className='text-xs'>
                      {lang?.rons_tips?.write_for_city}
                    </span>
                  </div>
                  <div className='mt-2 flex items-center justify-between gap-3 text-sm font-bold'>
                    {lang?.rons_tips?.apply_as_citywriter}
                    <span>
                      <MdArrowRightAlt size={20} />
                    </span>
                  </div>
                </div>
              </Link>
            ) : null}
            <span className='mx-6 mb-[4px] mt-[20px] text-[14px] font-semibold uppercase text-mid'>
              {lang?.common?.account}
            </span>
            <div className='mx-4 flex flex-col'>
              {userDetails &&
                userDetails?.is_admin == 1 &&
                userDetails?.admin_url && (
                  <MenuItem
                    label={lang?.common?.admin_dashboard}
                    link={userDetails?.admin_url}
                    // link={`${process.env.NEXT_PUBLIC_BACKEND_URL}/core/dashboard`}
                    style='font-bold'
                  />
                )}
              <MenuItem
                label={
                  getAccountType() === 'Individual'
                    ? lang?.common?.user_dashboard
                    : lang?.common?.company_dashboard
                }
                link={`${process.env.NEXT_PUBLIC_FRONTEND_URL}/dashboard?city=${city}`}
                style='font-bold'
              />
              {userDetails &&
              userDetails?.citywritter_approved == 1 &&
              userDetails?.is_admin != 1 ? (
                <MenuItem
                  label={lang?.common?.citywriter_dashboard}
                  link={userDetails?.admin_url}
                  style='font-bold'
                />
              ) : null}
            </div>

            <span className='mx-6 mb-[4px] mt-[24px] text-[14px] font-semibold uppercase text-mid'>
              {lang?.common?.settings}
            </span>
            <div className='mx-4 flex flex-col'>
              <MenuItem
                label={lang?.common?.account_settings}
                link={{
                  pathname: `${process.env.NEXT_PUBLIC_FRONTEND_URL}/account-settings`,
                  query: { city, tab: 'general_settings' },
                }}
              />
              <MenuItem
                label={lang?.common?.upgrade_plan}
                link={SUBSCRIPTION_ROUTE(city)}
              />
              <MenuItem
                label={lang?.market?.advertise_on_ron_orp}
                link={`${process.env.NEXT_PUBLIC_FRONTEND_URL}/advertise-on-ron-orp`}
              />
            </div>
          </nav>
          <div className='mt-4 flex w-full items-center justify-center border-t px-6 pt-4'>
            <LogoutButton className='w-full' />
          </div>
        </>
      )}
    </div>
  );
}
